import axios from "axios";

import { FCM_BASE_URL, firebaseConfig as Config } from "../api";

export default store => {
  return {
    $store: store,
    sendNotification(to, title, message, iconUrl) {
      let data = {
        to: to,
        notification: {
          title: title,
          body: message,
          icon: iconUrl
        },
        data: {
          title: title,
          body: message
        },
        webpush: {
          headers: {
            Urgency: "high"
          },
          notification: {
            body: message,
            requireInteraction: "true"
          }
        }
      };
      return axios(
        Object.assign(Config(store), {
          method: "post",
          url: FCM_BASE_URL + `/send`,
          data: JSON.stringify(data)
        })
      )
        .then(response => {
          return response.data;
        })
        .catch(error => {
          throw error;
        });
    }
  };
};
